import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("title3", component(opts));
  editor.BlockManager.add("title3", block(opts));
};